import {
    Service
  } from '../service.js'
  import {
    env
  } from '../env.js'
  
  class TemplateFormulaioService extends Service {
    constructor(controleDeInstancia) {
      super(controleDeInstancia);
  
      this.url = env.url + "template-formulario";
      
      this.controladoresDeInstancia = {
        listar: new AbortController(),
        adquirir: new AbortController(),
        save: new AbortController(),
      }
    }
  
    async listar(objetoDeFiltros, controlador) {
      this.controladoresDeInstancia.listar = this.selecionarControlador(controlador);
      const queryString = this.converterObjetoDeFiltrosParaURIEncodedString(objetoDeFiltros);
      return super.get(`${this.url}${queryString}`, this.controladoresDeInstancia.listar);
    }

    async adquirirPorId(id, controlador) {
      this.controladoresDeInstancia.adquirir = this.selecionarControlador(controlador);
      return super.get(`${this.url}/${id}`, this.controladoresDeInstancia.adquirir);
    }

    async salvar(formData, controlador) {
      this.controladoresDeInstancia.save = this.selecionarControlador(controlador);
      const response = await super.save(this.url, formData, this.controladoresDeInstancia.save);
      if (response.ok) {
          return response;
      } else {
          console.error("ERR: Não foi possível salvar o template de formulário.");
          const responseJson = await response.json()
          throw new Error(responseJson.message? responseJson.message : `HTTP ${response.status}`);
      }
    }

    async delete(item) {
      try {
        await super.delete(this.url, item);
      } catch (e) {
        console.error(e)
        throw new Error(`Ocorreu um erro ao excluir o formulário`);
      }
    }
  }

  export const templateFormularioService = new TemplateFormulaioService()
  